module.exports = __webpack_public_path__ + "static/media/globe-asia.e4f7f701.svg";